/**
 * SessionWarningModal
 * -------------------
 * Observes SessionManager state. When `isWarning` is true, renders a modal
 * with a live countdown and two actions:
 *   - "Stay signed in" → SessionManager.refresh() (silent Cognito refresh)
 *   - "Sign out"       → SessionManager.logout() (user-initiated logout)
 *
 * Rendered once at the app root (both artist-ui and main-ui). Uses the same
 * HFMModalNeo chrome as the rest of the CMS for visual consistency.
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import HFMModalNeo from '../hfm-modal-neo';
import sessionManager from '../../session/session-manager';

const formatCountdown = (secs) => {
	const m = Math.floor(secs / 60);
	const s = String(secs % 60).padStart(2, '0');
	return `${m}:${s}`;
};

@observer
class SessionWarningModal extends Component {
	@autobind
	handleStay () {
		sessionManager.refresh();
	}

	@autobind
	handleSignOut () {
		sessionManager.logout();
	}

	render () {
		const { isWarning, secondsRemaining } = sessionManager;

		return (
			<HFMModalNeo
				isOpen={ isWarning }
				contentLabel="Session expiring"
				shouldCloseOnOverlayClick={ false }
			>
				<div className="session-warning-modal">
					<h3 className="session-warning-modal__title">Your session is about to expire</h3>
					<p className="session-warning-modal__body">
						For your security, you'll be signed out in{' '}
						<strong className="session-warning-modal__countdown">
							{ formatCountdown(secondsRemaining) }
						</strong>.
						Click "Stay signed in" to keep working.
					</p>
					<div className="session-warning-modal__actions">
						<button
							className="button neo"
							type="button"
							onClick={ this.handleSignOut }
						>
							Sign out
						</button>
						<button
							className="button neo primary"
							type="button"
							onClick={ this.handleStay }
						>
							Stay signed in
						</button>
					</div>
				</div>
			</HFMModalNeo>
		);
	}
}

export default SessionWarningModal;
